import { render, staticRenderFns } from "./view_doc_card.vue?vue&type=template&id=52a3f36f&scoped=true"
import script from "./view_doc_card.vue?vue&type=script&lang=js"
export * from "./view_doc_card.vue?vue&type=script&lang=js"
import style0 from "./view_doc_card.vue?vue&type=style&index=0&id=52a3f36f&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52a3f36f",
  null
  
)

export default component.exports